// extracted by mini-css-extract-plugin
module.exports = {"content_container":"AreYouSurePopup_content_container__2o_Se"};